<template>
  <div class="latest-apps-section">
    <div class="container">
      <div class="section-title">
            <div class="big-title"> 
             <span class="sub-title-shadow text-capitalize">Related</span>
        <span class="sub-title text-uppercase">Related Apps</span>
        <h2>Explore Our Related Apps</h2>
      </div>
            </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 mb-4" v-for="app in apps" :key="app.slug">
          <div class="single-app-card">
            <router-link :to="`/app-detail/${app.slug}`">
              <div class="app-images">
                <div v-if="app.screenshot_1?.url && app.screenshot_2?.url" class="check-related">
                    <div class="phone phone-left">
                  <img
                    :src="$backendUrl + app.screenshot_1.url"
                    :alt="app.screenshot_1?.alternativeText || app.title || app.name || 'App Screenshot 1'"
                    class="img-fluid left-img"
                    
                  />
                  </div>
                  <div class="phone phone-right">
                  <img
                    :src="$backendUrl + app.screenshot_2.url"
                    :alt="app.screenshot_2?.alternativeText || app.title || app.name || 'App Screenshot 2'"
                    class="img-fluid right-img"
                
                  />
                  </div>
                </div>
                <img
                  v-else-if="app.screenshot_1?.url"
                  :src="$backendUrl + app.screenshot_1.url"
                  :alt="app.screenshot_1?.alternativeText || app.title || app.name || 'App Screenshot 1'"
                  class="img-fluid"
                  style="width:100%;height:200px;object-fit:contain;"
                />
                <img
                  v-else-if="app.screenshot_2?.url"
                  :src="$backendUrl + app.screenshot_2.url"
                  :alt="app.screenshot_2?.alternativeText || app.title || app.name || 'App Screenshot 2'"
                  class="img-fluid"
                  style="width:100%;height:200px;object-fit:contain;"
                />
                <img
                  v-else
                  :src="meanderLogo"
                  alt="Meander Software Placeholder"
                  class="img-fluid"
                  style="width:100%;height:200px;object-fit:contain;"
                />
              </div>
            </router-link>
            <div class="content mt-3">
              <h3 class="mb-2">
                <router-link :to="`/app-detail/${app.slug}`">{{ app.title || app.name }}</router-link>
              </h3>
              <span class="date">
                <i class="ri-stack-fill"></i> {{ app?.categorories[0]?.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, getCurrentInstance } from 'vue';
import meanderLogo from '../../assets/images/black-logo.png';
const props = defineProps({
  apps: {
    type: Array,
    required: true
  }
});

function formatDate(dateString) {
  if (!dateString) return '';
  return new Intl.DateTimeFormat('default', { dateStyle: 'long' }).format(new Date(dateString));
}

</script>
<style scoped>
.latest-apps-section {
  background: #fff;
}
.single-app-card {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  transition: box-shadow 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  background: linear-gradient(279.99deg, #9F5FF196 -1.19%, #FF54B042 50.99%, #FF9F5A69 100%);
  text-align: center;
}

.app-images {
    background-color: #eeeeee17;
    border-bottom: 1px solid #eee;
    border-radius: 100px;
    box-shadow: rgb(17 17 26 / 7%) 0px 1px 0px;
}
.single-app-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
}

.check-related {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;
  overflow: hidden;
}
.check-related img {
    height: 220px !important;
}
.phone {
  width: 160px; 
  position: relative;
}

.phone img {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

.phone-left {
  z-index: 1;
  margin-left: -75px;
}
.phone.phone-left img {
    height: 220px !important;
}
.phone.phone-right {
    transform: translateY(19px);
}



</style> 